<div class="d-flex flex-column h-100 w-100 align-items-stretch align-content-stretch">
	<ng-content></ng-content>
</div>
